<main class="auth">
  {{#if loginPath}}
  {{{signIn}}}
  {{/if}}
  {{#if registrationPath}}
  {{{signUp}}}
  {{/if}}
</main>
